/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var Hierarchy = function Hierarchy(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Hierarchy icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['icon--hierarchy', 'icon--hierarchy-2'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: gradientIds['icon--hierarchy'],
    cx: "36",
    cy: "36",
    r: "36"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#f3f3f3",
    overflow: "visible",
    xlinkHref: "#".concat(gradientIds['icon--hierarchy'])
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: gradientIds['icon--hierarchy-2']
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#".concat(gradientIds['icon--hierarchy'])
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 28h48v32H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24h48v4H12zm32.1 11.8H22.3c-.3 0-.6-.3-.6-.8s.3-.8.6-.8h21.8c.3 0 .6.3.6.8s-.3.8-.6.8zm-.6 6H26.2c-.3 0-.6-.3-.6-.8s.3-.8.6-.8h17.3c.3 0 .6.3.6.8s-.3.8-.6.8zm4.5 6H26.2c-.3 0-.6-.3-.6-.8s.3-.8.6-.8H48c.3 0 .6.3.6.8s-.3.8-.6.8zm-8.4 6H22.3c-.3 0-.6-.3-.6-.8s.3-.8.6-.8h17.3c.3 0 .6.3.6.8s-.3.8-.6.8z",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20.9",
    cy: "41",
    r: "1.5",
    fill: "#6c7185"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20.9",
    cy: "47",
    r: "1.5",
    fill: "#6c7185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 33.4l-1.3 2.2c-.1.2 0 .4.2.4h2.6c.2 0 .3-.2.2-.4l-1.3-2.2c-.1-.2-.3-.2-.4 0zm0 18.4L15.5 54c-.1.2 0 .4.2.4h2.6c.2 0 .3-.2.2-.4l-1.3-2.2c-.1-.2-.3-.2-.4 0z",
    fill: "#6c7185"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "49.3",
    cy: "14.5",
    r: ".8",
    fill: "#6c7185"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "38.6",
    cy: "6.5",
    r: ".8",
    fill: "#6c7185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.7c1.1 0 2-.9 2-2 0-.3.2-.5.5-.5s.5.2.5.5c0 1.1.9 2 2 2 .3 0 .5.2.5.5s-.2.5-.5.5c-1.1 0-2 .9-2 2 0 .3-.2.5-.5.5s-.5-.2-.5-.5c0-1.1-.9-2-2-2-.3 0-.5-.2-.5-.5s.2-.5.5-.5zM71.2 59.2h-1.7c-.4 0-.8.3-.8.8s.3.8.8.8h1.7c.4 0 .8-.3.8-.8s-.3-.8-.8-.8zm-6.2 0h-4.3V24c0-.4-.3-.8-.8-.8H12c-.4 0-.8.3-.8.8v35.2H.7c-.4 0-.7.4-.7.8s.3.8.8.8H65c.4 0 .8-.3.8-.8s-.3-.8-.8-.8zM12.7 24.8h46.5v2.5H12.7v-2.5zm0 4h46.5v30.5H12.7V28.8z",
    fill: "#6c7185"
  })));
};
Hierarchy.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var Hierarchy$1 = Hierarchy;

export { Hierarchy$1 as default };
